import React from "react";
import Eliminated from 'material-ui/svg-icons/action/highlight-off';
import NotEliminated from 'material-ui/svg-icons/action/done';

const containerStyle = {
  whiteSpace: "nowrap",
  width: 103,
  textAlign: "center",
  overflow: 'hidden',
  margin: '0px 0px',
  flex: 1,
  maxWidth: 103
};

const iconStyle = {
  // marginRight: -33
};

const badgeStyle = {
  width: 16,
  height: 16,
  padding: 2,
  textAlign: "center",
  top: -6,
  color: 'black',
  borderRadius: 3,
  display: 'inline-block',
  fontSize: 14,
  fontWeight: 'bold',
  zIndex: 0,
  position: 'relative',
  backgroundColor: 'limegreen',
  border: '1px solid limegreen',
  marginRight: 14,
  marginLeft:16
}

const eliminatedBadgeStyle = {
  ...badgeStyle,
  color:'white',
  backgroundColor: 'black',
  borderColor: 'black',
  marginLeft:-5
}

const elimStyleWhenBoth = {borderRadius: '3px 0px 0px 3px',  marginRight: 0, marginLeft: -15}
const metStyleWhenBoth = {borderRadius: '0px 3px 3px 0px', marginRight: 2, marginLeft: 0}

export const EliminatedIcon = () => <Eliminated color="red" style={iconStyle} />
export const PassIcon = () => <NotEliminated style={iconStyle} color="limegreen" />

const PassFailCriteria = ({eliminatedBy, metCriteria, onClick}) => (
  <div style={{...containerStyle}}>
    <div onClick={onClick} style={{height: 30, position: 'relative', cursor: 'pointer'}}>
      { eliminatedBy.length ? <EliminatedIcon /> : <PassIcon /> }
      {
        eliminatedBy.length !== 0 ? (
          <div style={{position: 'relative', display:'inline-block', marginLeft:20}}>
          {
            metCriteria.length ? (<span>
              <div style={{...eliminatedBadgeStyle, ...elimStyleWhenBoth}}>{eliminatedBy.length}</div>
              <div style={{...badgeStyle, ...metStyleWhenBoth}}>{metCriteria.length}</div>
            </span>) : <span>
              <div style={{...eliminatedBadgeStyle}}>{eliminatedBy.length}</div>
            </span>
          }
          </div>
        ) : (
          <div style={{...badgeStyle}}>{metCriteria.length}</div>
        )
      }
    </div>
  </div>
)

PassFailCriteria.style = containerStyle;

export default PassFailCriteria;
